import { render, staticRenderFns } from "./VerEstimacionIngresosPorSede.vue?vue&type=template&id=5a17c7db&scoped=true"
import script from "./VerEstimacionIngresosPorSede.vue?vue&type=script&lang=js"
export * from "./VerEstimacionIngresosPorSede.vue?vue&type=script&lang=js"
import style0 from "./VerEstimacionIngresosPorSede.vue?vue&type=style&index=0&id=5a17c7db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a17c7db",
  null
  
)

export default component.exports